module.exports = __webpack_public_path__ + "static/tedla-fshot-kesto-c1328988aaf8a7ab111d027153a804cf.jpeg";